import { FORGET_PASSWORD, FORGET_PASSWORD_ERROR, FORGET_PASSWORD_SUCCESS } from './actionTypes';

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  forgetLoading: false,
};

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        forgetLoading: true,
      };
      break;
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
        forgetLoading: false,
      };
      break;
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload, forgetLoading: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default forgetPassword;
